import templateStr from 'text!./policy-summary.html';
import PolicyLandingUtil from 'edge/gateway/util/policylanding/PolicyLandingUtil';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            gwPolicySummary: '=',
            showAccount: '=',
            showPremium: '=',
            noResultsMessage: '@'
        },
        controller: ['$scope', ($scope) => {
            const now = new Date().getTime();
            $scope.getPolicyTypeIcon = PolicyLandingUtil.getPolicyTypeIcon;
            $scope.isActive = (line) => {
                return new Date(line.effective).getTime() < now;
            };
        }]
    };
}];
